import type { RegistryEntry } from '../types';
import { VIDEO_UPSCALER_MODELS, DEFAULT_VIDEO_UPSCALER_MODEL } from '../../wavespeed/configs/upscaler';

const MODEL_LABELS: Record<string, string> = {
    'wavespeed-ai/video-upscaler': 'Standard',
    'wavespeed-ai/video-upscaler-pro': 'Pro',
    'wavespeed-ai/ultimate-video-upscaler': 'Ultra',
    'wavespeed-ai/seedvr2/video': 'SeedVR2',
    'wavespeed-ai/flashvsr': 'FlashVSR',
};

export const upscalerConfigs: Record<string, RegistryEntry> = {
    'video-upscaler': {
        options: [
            {
                key: 'upscaler_model',
                label: 'Model',
                type: 'select',
                options: VIDEO_UPSCALER_MODELS.map((m) => ({ label: MODEL_LABELS[m] ?? m, value: m })),
                default: DEFAULT_VIDEO_UPSCALER_MODEL,
                group: 'inline',
            },
        ],
        toProviderOptions: (ui) => {
            const m = typeof ui.upscaler_model === 'string' ? ui.upscaler_model : DEFAULT_VIDEO_UPSCALER_MODEL;
            return { upscaler_model: m } as unknown as Record<string, Record<string, any>>;
        },
    },
};